import GroupedConsignmentCard from "./GroupedConsignmentCard";

export default GroupedConsignmentCard;
